import React, { useEffect, useState } from 'react';
import { useAdminAuth } from '../AdminAuthContext';

const StatCard = ({ label, value, icon, color }) => (
  <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 flex items-center gap-4">
    <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${color}`}>
      <span className="material-icons text-white text-2xl">{icon}</span>
    </div>
    <div>
      <p className="text-2xl font-extrabold text-gray-900">{value ?? '—'}</p>
      <p className="text-sm text-gray-500">{label}</p>
    </div>
  </div>
);

const DashboardPage = () => {
  const { authFetch } = useAdminAuth();
  const [stats, setStats] = useState({ leads: null, contacts: null, newLeads: null });

  useEffect(() => {
    Promise.all([
      authFetch('/api/leads?limit=1').then(r => r.json()),
      authFetch('/api/contacts?limit=1').then(r => r.json()),
      authFetch('/api/leads?limit=1&status=new').then(r => r.json()),
    ]).then(([leads, contacts, newLeads]) => {
      setStats({ leads: leads.total, contacts: contacts.total, newLeads: newLeads.total });
    }).catch(() => {});
  }, [authFetch]);

  return (
    <div>
      <h2 className="text-xl font-bold text-gray-900 mb-6">Dashboard</h2>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <StatCard label="Total de Leads" value={stats.leads} icon="people" color="bg-blue-600" />
        <StatCard label="Novos Leads" value={stats.newLeads} icon="fiber_new" color="bg-emerald-600" />
        <StatCard label="Contatos Recebidos" value={stats.contacts} icon="mail" color="bg-violet-600" />
      </div>
    </div>
  );
};

export default DashboardPage;
